import { FC } from 'react';
import { FileDataSourceRadioButtonText } from './FileDataSourceRadioButtonText';

type FIleDataSourceRadioButtonProps = {
  title: string;
  description: string;
  currentValue: string;
  value: string;
  onClick: () => void;
};

export const FileDataSourceRadioButton: FC<FIleDataSourceRadioButtonProps> = ({ title, description, currentValue, value, onClick }) => {
  return (
    <button
      onClick={onClick}
      className='inline-flex w-3/4 cursor-pointer gap-3 rounded-xl border p-5'
    >
      <input type='radio' className='form-radio translate-y-1 cursor-pointer' name='radio' value={value} readOnly checked={currentValue === value} />
      <div className='flex flex-col gap-1 text-left'>
        <FileDataSourceRadioButtonText classNames='font-semibold' text={title} />
        <FileDataSourceRadioButtonText text={description} />
      </div>
    </button>
  );
};
